import { render, staticRenderFns } from "./VehicleRefStandardized.vue?vue&type=template&id=491faee5&scoped=true"
import script from "./VehicleRefStandardized.vue?vue&type=script&lang=js"
export * from "./VehicleRefStandardized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491faee5",
  null
  
)

export default component.exports